import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function AddConsultant() {

  const [errorMsg, seterrorMsg] = useState('');
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [cons,setCons] = useState([]);
  const [consdept,setConsDept] = useState([]);
  const [gender, setGender] = useState("male"); // set default value to "male"
  const [succesMsg, setsuccessMsg] = useState('');
  const [registerFormData, setRegisterFormData] = useState({
        "my_title":'',
        "cons_id":'',
        "consultant":'',
        "specialization":'',
        "department":'',
        "fees":'',
        "drfees":'',
        "visiting":'',
        "mobile":'',
        "address":'',
        "gender":'',
        "email":'',
        "hours":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
  const handleInputChange = (event) => {
    setGender(event.target.value);
  };
  const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.value
        })
  };

  const submitHandler = (e) => {
     e.preventDefault();
        axios.post(`${baseUrl}get_cons_id/`)
          .then(response => {
        const cons_id = response.data.value;
        const formData = new FormData();
        const department = document.getElementById("department").value;
        const visiting = document.getElementById("visiting").value;
        const hours = document.getElementById("hours").value;
        formData.append('my_title','Dr.');
        formData.append('cons_id',cons_id);
        formData.append('consultant',registerFormData.consultant);
        formData.append('specialization',registerFormData.specialization);
        formData.append('department',department);
        formData.append('fees',registerFormData.fees);
        formData.append('drfees',registerFormData.drfees);
        formData.append('visiting',visiting);
        formData.append('mobile',registerFormData.mobile);
        formData.append('address',registerFormData.address);
        formData.append('gender',gender);
        formData.append('hours',hours);
        formData.append('email',registerFormData.email);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

        axios.post(baseUrl+'add-consultant/', formData)
          .then((response) => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'consultant has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setRegisterFormData({
                  my_title: '',
                  cons_id: '',
                  consultant: '',
                  specialization: '',
                  department: '',
                  fees:'',
                  drfees:'',
                  visiting:'',
                  gender: '',
                  mobile: '',
                  address: '',
                  hours: '',
                  email: '',
                  status: '',
                  addedby: '',
                  ip_add: '',
                });
                setTimeout(() => {
                  window.location.href = '/add-consultant/';
                }, 3000);
              }
            })
              .catch(error => {
              console.log(error);
                  Swal.fire(
                    'Error!',
                    'Failed to add consultant. Please try again later.',
                    'error'
                  );
              });
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to generate unique value. Please try again later.',
                'error'
            );
          });
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (cons.length > 0) {
        setRows(cons);
      }
  }, [cons]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}cons-search/`)
      .then(response => {
        setCons(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
      axios.get(`${baseUrl}cons-dept/`)
      .then(response => {
        setConsDept(response.data);
        setIsLoading(false);
      });
  }
    const handleDelete = (cons_id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-consultant/'+cons_id)
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                      window.location.reload();
                    });
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
  const columns = [
    { field: 'id', headerName: 'Id', width: 50 },
    { field: 'cons_id', headerName: 'Cons Id', width: 120 },
    { field: 'consultant', headerName: 'Consultant', width: 150 },
    { field: 'specialization', headerName: 'Spl.', width: 80 },
    { field: 'department', headerName: 'Department', width: 120},
    { field: 'visiting', headerName: 'Visiting', width: 80},
    { field: 'fees', headerName: 'Fees', width: 80},
    { field: 'mobile', headerName: 'Mobile', width: 100},
    { field: 'address', headerName: 'Address', width: 150},
    { field: 'edit', headerName: 'Edit',
        renderCell: (params) => (
          <Link to={`/edit-consultant/${params.row.id}`} target="_blank" className="btn btn-warning">
            Edit
          </Link>
      ),
      width: 120 },
      { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
      width: 120 },

  ];

    const buttonEnable = (registerFormData.consultant!='') && (registerFormData.specialization!='') && (registerFormData.mobile!='')
  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className='card'>
                    <h4 className='card-header text-center'>New Consultant Registration</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                        <label htmlFor="Consultant" className="form-label">Consultant Name</label>
                            <input type="text" placeholder="consultant Name" className="form-control"
                               name="consultant" value={registerFormData.consultant} onChange={inputHandler} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="specialization" className="form-label">specialization</label>
                            <input type="text" placeholder="specialization" className="form-control"
                               name="specialization" value={registerFormData.specialization} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                        <label htmlFor="Role" className="form-label">Department</label>
                              <select className="form-control" value={registerFormData.department} onChange={inputHandler}
                                name="department" id="department">
                                {consdept.map((department,index) => {return <option key={index} value={department.department}>{department.department}
                                </option>})}
                              </select>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Fees" className="form-label">Fees</label>
                            <input type="number" maxLength={10} placeholder="Fees" className="form-control"
                                name="fees" value={registerFormData.fees} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="DrFees" className="form-label">DrFees</label>
                            <input type="number" maxLength={10} placeholder="DrFees" className="form-control"
                                name="drfees" value={registerFormData.drfees} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Role" className="form-label">Visiting Hour</label>
                              <select className="form-control" value={registerFormData.visiting} onChange={inputHandler}
                                name="visiting" id="visiting">
                                <option value="Full-time">Full-time</option>
                                <option value="Part-time">Part-time</option>
                                <option value="On-Call">On-Call</option>
                              </select>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Mobile" className="form-label">Mobile</label>
                            <input type="number" maxLength={10} placeholder="Mobile" className="form-control"
                                name="mobile" value={registerFormData.mobile} onChange={inputHandler} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="Address" className="form-label">Address</label>
                            <input type="text" placeholder="Address" className="form-control"
                               name="address" value={registerFormData.address} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                        <label htmlFor="Gender" className="form-label">Gender</label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="male" checked={gender === "male"}
                             onChange={handleInputChange}/> Male
                            </label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="female" checked={gender === "female"}
                             onChange={handleInputChange} /> Female
                            </label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="transgender" checked={gender === "transgender"}
                             onChange={handleInputChange} /> Transgender
                            </label>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="hours" className="form-label">Hours</label>
                            <select className="form-control" value={registerFormData.hours} onChange={inputHandler}
                              name="hours" id="hours">
                            <option value="2">2</option>
                            <option value="4">4</option>
                            <option value="6">6</option>
                            <option value="8">8</option>
                            <option value="10">10</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="email" className="form-label">Email</label>
                            <input type="text" placeholder="Email" className="form-control"
                               name="email" value={registerFormData.email} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-12 text-center">
                        <button type="button" disabled={!buttonEnable} onClick={submitHandler}
                        className="btn btn-success">Register</button>
                        </div>
                        </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
            <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={rows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          </div>
        </section>
  );
}

export default AddConsultant;
